import { isAuthorized } from '../../services/trackWindow';
import ActionTypes from '../actionTypes/actionTypes';
import { ToastsStore } from '@bnsf/bnsf-react-toast-messages';

export const isUserAuthorized = (userProfile) => dispatch => {   
    return isAuthorized(userProfile)
        .then(response => {            
            dispatch(isUserAuthorizedSuccess(response));
        }).catch((err) => {
            ToastsStore.showToast("AUTHORIZATION_FAILURE");
            console.log(err);

            dispatch(isUserAuthorizedSuccess(false));            
        });
}

const isUserAuthorizedSuccess = isAuthorized => ({
    type: ActionTypes.IS_USER_AUTHORIZED_SUCCESS,
    isAuthorized
});